import React, { useEffect } from 'react'

export default function DotPhrase({
  snippets,
  dotPhrasePosition,
  closeDotPhrase,
  onSelectSnippet,
  highlightedSnippet,
  setHighlightedSnippet,
}) {
  useEffect(() => {
    if (snippets.length === 0) {
      closeDotPhrase()
    }
  }, [snippets])

  return (
    <div
      id={'dotPhraseBox'}
      style={{
        top: dotPhrasePosition.top + 15 + 'px',
        left: Math.min(dotPhrasePosition.left + 10, 800) + 'px',
      }}
    >
      <h6
        style={{
          textAlign: 'center',
          borderBottom: '2px solid black',
          marginBottom: 0,
          cursor: 'default',
        }}
      >
        Snippets
      </h6>
      {snippets.map((snip, index) => {
        return (
          <div
            key={snip._id}
            className={index === highlightedSnippet ? 'highlighted' : ''}
            onClick={() => onSelectSnippet(snip.snippets)}
            onMouseEnter={() => setHighlightedSnippet(index)}
          >
            {snip.title}
          </div>
        )
      })}
    </div>
  )
}
